var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-item',{on:{"click":_vm.openVersions}},[_vm._v("Versionshistorik")])}
var staticRenderFns = []

export { render, staticRenderFns }